export default class TelemetryService {
    reportEvent(event, properties) {
        throw new Error("Method 'reportEvent(event, properties)' must be implemented.");
    }
    
    debugEvent(event, properties) {
        console.log(`TelemetryService.debugEvent(${event}, ${JSON.stringify(properties)})`);
    }
}